import React, { useEffect, useState } from "react";

import { Image } from "Components/atoms/Image";
import { Typography } from "Components/atoms/Typography";
import { AdBannerContainerDesktop } from "Components/molecules/AdBannerHeader/Desktop";
import { RandomBackgroundSection } from "Components/molecules/RandomBackgroundSection";
import { SearchFlightsDesktop } from "../../SearchFlights/Desktop";

import { imagesBackgroundBanner } from "shared/config/imagesBackgroundBannerConfig";

import { HeroContentWrapper, HeroHeadWrapper } from "./styles";

import PlaneIconImage from "assets/images/icons/plane.png";
import { theme } from "styles/theme";
import { GoogleBannerAd } from "Components/molecules/GoogleAds/GoogleBannerAd";
import { AdBannerContainer } from "Components/molecules/AdBanner";
import { useGeneralContext } from "shared/contexts/GeneralContext";

/**
 * Componente HeroSectionDesktop
 *
 * Exibe uma seção heroica com fundo dinâmico, texto e formulário de busca.
 */
export const HeroSectionDesktop: React.FC = () => {
  const images = imagesBackgroundBanner;
  const { isSERP } = useGeneralContext();

  return (
    <RandomBackgroundSection images={images} height="600px">
      <HeroContentWrapper>
        <HeroHeadWrapper>
          <Image src={PlaneIconImage} alt="Ícone de avião" />
          <h1 style={{ fontSize: theme.fontSizes.xxl }}>
            Compare e encontre as passagens aéreas mais baratas
          </h1>
        </HeroHeadWrapper>
      </HeroContentWrapper>
      <SearchFlightsDesktop />

      {isSERP ? (
        <AdBannerContainer
          slotId="div-gpt-ad-1748863889389-0"
          adUnit="/27140001/728x90_HomeDesk"
          sizes={[[970, 90]]}
        />
      ) : (
        <AdBannerContainer
          slotId="div-gpt-ad-1748863775645-0"
          adUnit="/27140001/2024-home-desktop-footer-970x90"
          sizes={[[970, 90]]}
        />
      )}
    </RandomBackgroundSection>
  );
};
